import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, FontIcon } from 'react-md';
import {
  withRouter,
  Link as RouterLink,
  // Redirect
} from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import { reduce, compact, isEqual, get, omit, find, isEmpty } from 'lodash-es';
import { fromJS } from 'immutable';

import Chip from '@material-ui/core/Chip';
import Link from '@material-ui/core/Link';

import { withSnackbar } from 'notistack';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import { SchemaForm } from '@coog/react-components';
import * as productsActions from '../../Services/Products/actions';
import * as quotationsActions from '../../Services/Quotations/actions';
import * as authActions from '../../Services/Auth/actions';
import * as partiesActions from '../../Services/Parties/actions';

import { preFillExtra, preFillLoan } from './preFill';
import CONFIG from '../../Config';

import { StatusQuote } from './renderer';
import { showAlerts } from '../Common/utils';

import { evalActionsState, asyncEvalActionsState, evalExpanded, defaultActionsState } from './utils';
import { getString } from '../../Utils/Utils';

import SubscribeDialog from './SubscribeDialog';

import './EditQuotation.scss';

// eslint-disable-next-line react/prop-types
const LinkItem = ({ label, value, route, theme = 'white' }) => {
  const link = props => <RouterLink to={route} {...props} />;
  return (
    <div className={`link item ${theme}`} style={{ display: 'inline', fontSize: '1.1rem', marginRight: '5px' }}>
      <Link
        title={label || value}
        component={React.forwardRef((props, ref) => link(props))}
        key={`summary-link-item-${label}`}
        target="_blank"
      >
        {label || value}
      </Link>
    </div>
  );
};

// eslint-disable
class EditQuotationSR extends Component {
  state = {
    quotation: {
      id: undefined,
    },
    redirect: undefined,
    alerts: {},
    loading: {},
    isLoadingLenderAddresses: false,
    actionsState: defaultActionsState,
    currentActionsState: defaultActionsState,
    updateActionsState: false,
    updateEvalActionsState: false,
    duplicateSR: {},
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let nextState = null;
    if (!isEqual(nextProps.alerts, prevState.alerts)) {
      nextState = { alerts: nextProps.alerts };
    }
    if (!isEqual(nextProps.loading, prevState.loading)) {
      nextState = { ...nextState, loading: nextProps.loading };
    }
    if (prevState.loading.isSubmittingQuotation && nextProps.currentContract) {
      nextState = {
        ...nextState,
        redirect: `/contracts/${nextProps.currentContract}`,
        actionsState: defaultActionsState,
        currentActionsState: defaultActionsState,
      };
    }
    if (prevState.loading.isSubmittingQuotations && nextProps.currentContract) {
      nextState = {
        ...nextState,
        redirect: '/contracts',
        actionsState: defaultActionsState,
        currentActionsState: defaultActionsState,
      };
    }

    if (prevState.loading.isLoadingValidate && !isEmpty(nextProps.duplicateSR)) {
      nextState = {
        ...nextState,
        duplicateSR: nextProps.duplicateSR,
      };
    } else if (!prevState.loading.isLoadingValidate && !isEmpty(nextProps.duplicateSR)) {
      nextState = {
        ...nextState,
        duplicateSR: {},
      };
    }

    if (prevState.loading.isCalculatingQuotation && !nextProps.loading.isCalculatingQuotation) {
      nextState.updateEvalActionsState = true;
    }

    if (
      !isEqual(nextProps.validate, prevState.validate) ||
      (prevState.loading.isCalculatingQuotation && !nextProps.loading.isCalculatingQuotation) ||
      (prevState.loading.isSubmittingQuotation && !nextProps.loading.isSubmittingQuotation) ||
      (prevState.loading.isSubmittingQuotations && !nextProps.loading.isSubmittingQuotations) ||
      (prevState.loading.isCancelingQuotation && !nextProps.loading.isCancelingQuotation)
    ) {
      nextState = { ...nextState, validate: nextProps.validate, updateActionsState: true };
    }
    return nextState;
  }

  componentDidMount() {
    const { actions, match, dateFormat } = this.props;
    this.setState({
      quotation: {
        id: match.params.id,
      },
    });
    actions.fetchQuotationSR({ id: match.params.id });
    // actions.fetchLenders();
    // this.initLenders();
    // actions.fetchKinds();
    actions.fetchDeferrals();
    actions.fetchGenders();
    // actions.fetchBanks();
    actions.fetchCommercialProductsV2({ date: new Date(), dateFormat });

  }

  componentDidUpdate(prevProps) {
    // eslint-disable-next-line no-unused-vars
    const { alerts: prevAlerts, loading: prevLoading, quotations: prevQuotations } = prevProps;
    // eslint-disable-next-line no-unused-vars
    const { alerts, loading, quotations, enqueueSnackbar, strings } = this.props;
    if (alerts && !isEqual(alerts, prevAlerts)) {
      showAlerts({ enqueueSnackbar, alerts, strings });
    }
    // this.initLenders();
    // this.initLenderAddresses();
    this.updateActionsState();
  }

  calcActionsState = (quotation, quotations, nextValues, withActionState) => {
    const { actionsState } = this.state;
    const { id } = quotation;
    const prevQuotation = get(quotations, `[${id}]`, {});
    const nextQuotation = { ...prevQuotation, ...nextValues };
    const directActionsState = evalActionsState({
      prevQuotation,
      nextQuotation,
      actionsState: withActionState ? actionsState : null,
    });
    return { directActionsState, nextQuotation };
  };

  updateActionsState = () => {
    const { validate, actionsState, currentActionsState, updateActionsState, updateEvalActionsState, quotation } =
      this.state;
    const { quotations } = this.props;
    let newActionsState = actionsState;

    if (updateEvalActionsState) {
      const { directActionsState } = this.calcActionsState(quotation, quotations, { offer: {} });

      directActionsState.hasCalculate = false;
      directActionsState.needCalculate = false;
      this.setState({ actionsState: directActionsState, updateEvalActionsState: false });
      newActionsState = directActionsState;
    }

    if (updateActionsState) {
      const { nextActionsState, asyncActionsState } = asyncEvalActionsState({
        validate,
        currentActionsState,
        quotations,
        quotation,
        actionsState: newActionsState,
      });
      this.setState({ updateActionsState: false });
      this.setState({ currentActionsState: asyncActionsState });
      this.setState({ actionsState: nextActionsState });
    }
  };

  // goBack = () => {
  //   const { history } = this.props;
  //   history.goBack();
  // };

  // initLenders = () => {
  //   const { actions, quotations, config, loading } = this.props;
  //   const isLoadingLenders = get(loading, 'isLoadingLenders', false);

  //   const id = get(this.state, 'quotation.id');
  //   const quotation = get(quotations, id);

  //   const lenders = get(config, 'loan.lenders.options', []);
  //   const isLoan = !!get(quotation, 'loan', false);
  //   if (!isLoadingLenders && isLoan && lenders.length === 0) {
  //     actions.fetchLenders();
  //   }
  // };

  // initLenderAddresses = () => {
  //   const { actions, quotations } = this.props;
  //   const { isLoadingLenderAddresses } = this.state;
  //   // const isNotLoaded = get(config, 'loan.lenderAddresses.options', []).length === 0;
  //   if (!isLoadingLenderAddresses) {
  //     const id = get(this.state, 'quotation.id');
  //     const quotation = get(quotations, id);
  //     const loans = get(quotation, 'loan', []);
  //     loans.forEach(loan => {
  //       const lenderId = get(loan, 'lender');
  //       if (lenderId) {
  //         this.setState({
  //           isLoadingLenderAddresses: true,
  //         });
  //         actions.fetchLenderAddresses(lenderId);
  //       }
  //     });
  //   }
  // };

  cleanValues = values => {
    let newValues = values;
    // loans
    if (Array.isArray(newValues.loan)) {
      newValues = Object.assign(newValues, {
        loan: compact(values.loan).map(v =>
          Object.assign(
            v,
            (Array.isArray(v.increments) && v.increments.length) > 0 ? { increments: compact(v.increments) } : undefined
          )
        ),
      });
    }
    // covered
    if (Array.isArray(newValues.covered)) {
      newValues = Object.assign(newValues, { covered: compact(values.covered) });
    }
    return newValues;
  };

  // handleResetRedirect = () => {
  //   const { actions } = this.props;
  //   actions.resetRedirect();
  // };

  /* eslint-disables */
  render() {
    const {
      pageTitle,
      canonical,
      strings,
      quotations,
      actions,
      config,
      alerts,
      loading,
      validate,
      i18n,
      commercialProducts
      // location
    } = this.props;
    const { quotation, redirect, duplicateSR, currentActionsState } = this.state;
    const quotationId = get(quotation, 'id', '');

    if (loading.isLoadingQuotation) {
      return (
        <div className="spinner">
          <FontAwesomeIcon icon={faSpinner} size="lg" fixedWidth />
        </div>
      );
    }

    let subscribeDialog;
    let duplicateDialog;

    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {getString({
            strings,
            key: pageTitle,
            defaultString: 'Tarification',
            options: { quotationId },
          })}
        </title>
        <meta name="description" content={getString(strings, pageTitle, 'Tarification')} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const handleSubmit = values => {
      const { match } = this.props;
      actions.putQuotationSR({ id: match.params.id, payload: this.cleanValues(values) });
    };

    const handleCalculate = (...values) => {
      const { directActionsState } = this.calcActionsState(quotation, quotations, { ...values[0], offer: {} });

      const { state } = this;
      const newValues = state.actionsState.needCalculate ? { ...values[0], offer: {} } : { ...values[0] };

      directActionsState.hasCalculate = true;
      directActionsState.needCalculate = false;
      this.setState({ actionsState: directActionsState });

      if (!directActionsState.btn.calculated.disable) {
        actions.fetchCalculateQuotationSR(newValues);
        window.scrollTo({ top: 0 });
      }
    };

    const handleSubscribe = (...values) => {
      actions.submitQuotation(...values);
    };

    const handleSubscribes = (...values) => {
      const { directActionsState } = this.calcActionsState(quotation, quotations, { ...values[0] });
      this.setState({ actionsState: directActionsState });

      if (!directActionsState.btn.calculated.disable && !directActionsState.needCalculate) {
        actions.submitQuotationsSR(...values);
      } else {
        actions.needRecalculate([
          get(strings, 'quotation.error.needrecalculate', 'Merci de recalculer la tarification.'),
        ]);
      }
    };

    const handlePutOnHold = (...values) => {
      actions.putOnHoldQuotation(...values);
    };

    const handleCancel = (...values) => {
      actions.cancelQuotationSR(...values);
    };

    const handlePrint = (...values) => {
      actions.printQuotationSR(...values);
    };

    // eslint-disable-next-line no-unused-vars
    const handleChange = values => {
      const { quotations: localQuotations } = this.props;
      const { id } = quotation;
      const { directActionsState, nextQuotation } = this.calcActionsState(
        quotation,
        localQuotations,
        get(values, 'values'),
        true
      );

      // TODO: TO REMOVE [HACK]
      if (get(nextQuotation, 'subscriptions[0].addresses[0]')) {
        nextQuotation.subscriptions[0].addresses[0].country = 'FR';
      }
      if (get(nextQuotation, 'transform.addresses[0]')) {
        nextQuotation.transform.addresses[0].country = 'FR';
      }

      if (localQuotations[id]) localQuotations[id] = nextQuotation;

      this.setState({
        actionsState: directActionsState,
        quotation: nextQuotation,
        currentActionsState: directActionsState,
      });

      if (directActionsState.needCalculate) actions.resetOffer(quotation.id);

      if (nextQuotation.quote_status !== 'submitted' && nextQuotation.quote_status !== 'canceled') {
        actions.validateQuotationSR({ quotation: omit(nextQuotation, 'calc'), id: quotation });
      }
    };

    const handleDuplicate = value => {
      const commProduct = find(commercialProducts, { id: value });

      const data = {
        commercialProduct: {
          id: commProduct?.id,
          code: commProduct?.code,
        },
        product: {
          id: commProduct?.product?.id,
        },
      };

      actions.duplicateQuotationSR({ data, id: quotationId });
    };

    const handleClose = () => {
      this.setState({ duplicateSR: {} });
    };

    if (!isEmpty(duplicateSR)) {
      const { view } = this.props;
      const commProduct = find(commercialProducts, { id: duplicateSR.productId });
      const quotation = quotations?.[quotationId];

      const content = (
        <>
          <span>
            {get(
              strings,
              'quotation.edit.simple.duplicate.dialog.label',
              'Devis dupliqué avec succès pour le produit '
            )}
            <span className="product-name">{commProduct?.rec_name || ''}</span>.
            {commProduct?.id !== quotation?.commercial_product?.id && (
              <>
                <br />
                <br />
                <span className="icon">
                  <FontAwesomeIcon icon={faExclamationTriangle} size="lg" fixedWidth />
                </span>
                {get(
                  strings,
                  'quotation.edit.simple.duplicate.dialog.warning',
                  'Les champs spécifiques à ce produit ne sont pas dupliqués.'
                )}
              </>
            )}
            <br />
            <br />
            <LinkItem
              label={get(strings, 'quotation.edit.simple.duplicate.dialog.open', 'Ouvrir')}
              route={`/quotations/${duplicateSR.id}`}
              newTab={true}
              handlerClick={handleClose}
            />
          </span>
        </>
      );

      duplicateDialog = (
        <SubscribeDialog
          title={get(strings, 'quotation.edit.duplicate.dialog.title', '')}
          className="duplicate-dialog"
          buttonCloseLabel={get(strings, 'quotation.edit.duplicate.dialog.button.close', 'Fermer')}
          handleClose={handleClose}
          key={Date.now()}
        >
          {view === 'simple' ? (
            content
          ) : (
            <>
              <div className="icon">
                <FontIcon inherit>done_outline</FontIcon>
              </div>
              <div className="content">{content}</div>
            </>
          )}
        </SubscribeDialog>
      );
    }

    const contractLink = () => {
      const { id } = quotation;
      const quote = quotations[id];
      const contractLinks = get(quote, 'quoteNumbers', []).map(quoteNumber => (
        <div className="title-status breadcrumbs contract-link" key={`contract-link-${quoteNumber}`}>
          <LinkItem label={quoteNumber} value={quoteNumber} route={`/contracts/edit?quote_number=${quoteNumber}`} />
        </div>
      ));
      return contractLinks;
    };

    if (redirect) {
      const { view } = this.props;
      subscribeDialog = (
        <SubscribeDialog
          title={get(strings, 'quotation.edit.subscribe.dialog.title', '')}
          buttonCloseLabel={get(strings, 'quotation.edit.subscribe.dialog.button.close', 'Fermer')}
        >
          {view === 'simple' ? (
            <span>
              {get(
                strings,
                'quotation.edit.simple.subscribe.dialog.label',
                "Demande d'adhésion transmise au service gestion"
              )}
            </span>
          ) : (
            <>
              <div className="icon">
                <FontIcon inherit>done_outline</FontIcon>
              </div>
              <div className="content">
                <span>
                  {get(
                    strings,
                    'quotation.edit.subscribe.dialog.label.number',
                    "Demande d'adhésion transmise au service gestion"
                  )}
                </span>
              </div>
            </>
          )}
        </SubscribeDialog>
      );
    }

    const productName = (chip = true) => {
      const { id } = quotation;
      let name = '';
      if (quotations[id] && quotations[id].commercial_product) {
        name = chip ? (
          <Chip
            className="title-product product-name"
            label={quotations?.[id]?.commercial_product?.name}
            style={{
              paddingTop: '0',
              paddingBottom: '0',
              fontWeight: 'bold',
              fontSize: '0.85rem',
            }}
          />
        ) : (
          <span className="product-name">{quotations?.[id]?.commercial_product?.name}</span>
        );
      }
      return name;
    };

    const quoteStatus = () => {
      const { id } = quotation;
      return quotations[id] && quotations[id].quote_status ? (
        <div className="title-status breadcrumbs quote-status">
          <StatusQuote status={quotations[id].quote_status} strings={strings} />
        </div>
      ) : undefined;
    };

    const quoteNumber = () => {
      const { id } = quotation;

      const quoteNb = id ? (
        <div className="title-status breadcrumbs">
          <span className="quote-number">{id.substring(0, 8)}</span>
        </div>
      ) : undefined;

      return quoteNb;
    };

    const isReadOnly = status => {
      switch (status) {
        case 'submitted':
        case 'canceled': {
          return true;
        }
        default: {
          return false;
        }
      }
    };

    const renderForm = () => {
      const { id } = quotation;
      if (quotations[id] && quotations[id].calc) {
        // WORKAROUND: to prevent error from API: (0: ": should NOT have additional properties")
        // TODO: modify API service to accept full object
        const initialValues = {
          extra: preFillExtra(quotations[id]).extra,
          loan: preFillLoan(quotations[id]).loan,
          covered: quotations[id].covered,
          quote_status: quotations[id].quote_status,
          date: quotations[id].date,
          createdOn: quotations[id].createdOn,
          offer: quotations[id].offer,
          transform: quotations[id].transform,
          subscriptions: quotations[id].subscriptions,
          commercial_product: quotations[id].commercial_product,
          product: quotations[id].product,
          id: quotations[id].id,
        };
        const contract = quotations[id].calc ? quotations[id].calc.contract : {};
        const isLoan = get(contract, 'isLoan') || reduce(get(contract, 'covered', {}), (a, ce) => a || ce.loan, false);

        if (isLoan) {
          initialValues.release_date = quotations[id].release_date || quotations[id].date;
        }

        const readOnly = isReadOnly(quotations[id].quote_status);

        const duplicateBtn = {
          isLoadingValidate: loading.isLoadingValidate,
          selection: commercialProducts,
          handle: handleDuplicate,
        };
        try {
          console.log("🔍 duplicateBtn:", duplicateBtn);
          console.log("🔍 initialValues:", initialValues);
          console.log("🔍 contract:", contract);

          if (!duplicateBtn || !Array.isArray(duplicateBtn.selection)) {
            return <div>❌ duplicateBtn is invalid</div>;
          }

          if (!initialValues) {
            return <div>❌ initialValues is invalid</div>;
          }
          return (
            <>
              {subscribeDialog}
              {duplicateDialog}
              <SchemaForm
                // debug
                strings={strings}
                saveButtonLabel="Save"
                data={contract}
                initialValues={initialValues}
                onSave={handleSubmit}
                onChange={handleChange}
                isLoan={isLoan}
                actions={actions}
                config={config}
                alerts={alerts}
                id={id}
                onCalculate={handleCalculate}
                onSubscribe={handleSubscribe}
                onSubscribes={handleSubscribes}
                onPutOnHold={handlePutOnHold}
                onCancel={handleCancel}
                onPrint={handlePrint}
                loading={loading}
                actionsState={currentActionsState}
                readOnly={readOnly}
                apiBaseUrl={CONFIG.apiBaseUrl}
                expanded={evalExpanded({ quotations, quotation })}
                validate={get(validate, 'data')}
                i18n={i18n}
                singleCovered={get(quotations, `[${id}].productObj.item_descriptors[0].single_covered`, false)}
                duplicateBtn={duplicateBtn}
              />
            </>
          );
        } catch (err) {
          console.error('💡 SchemaForm crashed', err);
          return <div>Form crashed</div>;
        }
      }
      return undefined;
    };

    return (
      <div className="coog-app quotation">
        {helmet}
        <h1 className="md-title md-cell md-cell--12 coog-title">
          <span className="title-page">{getString(strings, pageTitle, 'Tarification')}</span>
          <div className="info">
            {productName(false)}
            {quoteNumber()}
            {quoteStatus()}
            {contractLink()}
          </div>
        </h1>
        <Grid className="coog-grid quotation-edit">{renderForm()}</Grid>
      </div>
    );
  }
}

EditQuotationSR.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  i18n: PropTypes.shape({
    lang: PropTypes.string,
  }).isRequired,
  // location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  match: ReactRouterPropTypes.match.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired, // eslint-disable-line
  actions: PropTypes.shape({
    fetchQuotationSR: PropTypes.func,
    putQuotationSR: PropTypes.func,
    fetchLenders: PropTypes.func,
    fetchLenderAddresses: PropTypes.func,
    fetchKinds: PropTypes.func,
    fetchDeferrals: PropTypes.func,
    fetchGenders: PropTypes.func,
    fetchCalculateQuotationSR: PropTypes.func,
    submitQuotation: PropTypes.func,
    submitQuotationsSR: PropTypes.func,
    printQuotationSR: PropTypes.func,
    putOnHoldQuotation: PropTypes.func,
    cancelQuotationSR: PropTypes.func,
    logout: PropTypes.func,
    validateQuotationSR: PropTypes.func,
    // fetchBanks: PropTypes.func,
    resetRedirect: PropTypes.func,
    validateIban: PropTypes.func,
    needRecalculate: PropTypes.func,
    resetOffer: PropTypes.func,
    fetchCommercialProductsV2: PropTypes.func,
  }).isRequired,
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  data: PropTypes.object, // eslint-disable-line
  quotations: PropTypes.any, // eslint-disable-line
  strings: PropTypes.objectOf(PropTypes.string),
  config: PropTypes.object, // eslint-disable-line
  alerts: PropTypes.object, // eslint-disable-line
  loading: PropTypes.object, // eslint-disable-line
  validate: PropTypes.object, // eslint-disable-line
  view: PropTypes.string,
  commercialproducts: PropTypes.array, // eslint-disable-line
  dateFormat: PropTypes.string.isRequired,

};

EditQuotationSR.defaultProps = {
  strings: {
    title: 'quotation',
    subtitle: undefined,
    'block.extra.title': 'Additional data',
    'btn.save.label': 'Save all',
    'block.btn.save.label': 'Save',
    'btn.collapse.label': 'Collapse all',
    'btn.expand.label': 'Expand all',
    'block.loan.title': 'Loan(s)',
    'block.loan.btn.add.label': 'Add a Loan',
    'block.loan.btn.remove.label': 'Remove',
    'block.loan.field.kind.label': 'Kind',
    'block.loan.field.amount.label': 'Amount',
    'block.loan.field.rate.label': 'Rate',
    'block.loan.field.duration.label': 'Duration',
    'block.loan.field.duration_unit.label': 'Duration Unit',
    'block.loan.field.payment_frequency.label': 'Payment Frequency',
    'block.loan.field.lender.label': 'Lender',
    'block.loan.field.lender_address.label': 'Lender Address',
    'block.loan.field.deferral.label': 'Deferral',
    'block.loan.field.deferral_duration.label': 'Deferral Duration',
    'block.loan.field.increments.payment_amount.label': 'Montant',
    'block.loan.field.increments.number_of_payments.label': "Nombre d'échéances",
    'block.loan.field.increments.payment_frequency.label': 'Fréquence de paiement',
    'block.covered.title': 'Assurés et Garanties',
  },
  pageTitle: 'title',
  canonical: 'http://www.coopengo.com/',
  data: {},
  quotations: [],
  config: {},
  alerts: fromJS({ warnings: [], errors: [], successes: [], infos: [] }),
  view: 'portal',
  validate: undefined,
  commercialProductsV2: [],
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => {
  const quotations = state.get('quotations').toJS();
  const commercialProducts = state.toJS().products.commercialproductsV2.map(product => ({
    ...product,
    value: product.id,
    label: product.name,
    name: product.name,
    product: product.technical_product,
  }));

  return {
    i18n: state.toJS().system.i18n,
    view: state.getIn(['system', 'view']),
    data: get(quotations, 'current.quotation'),
    quotations: get(quotations, 'quotations'),
    config: get(quotations, 'config'),
    strings: get(quotations, 'strings'),
    alerts: state.getIn(['quotations', 'alerts']),
    loading: get(quotations, 'loading'),
    validate: get(quotations, 'validate'),
    currentContract:
      state.getIn(['quotations', 'current', 'contract']) || state.getIn(['quotations', 'current', 'contracts']),
    commercialProducts,
    dateFormat: state.toJS().system.dateFormat,
    duplicateSR: get(quotations, 'duplicateSR'),
  };
};
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { ...productsActions, ...quotationsActions, ...authActions, ...partiesActions },
    dispatch
  ),
});

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(EditQuotationSR)));